module.exports = __webpack_public_path__ + "static/media/resou.a14feda5.png";